import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Heart } from "lucide-react";
import { FOUNDATION_LOGO } from "@/lib/initiatives";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/initiatives", label: "Initiatives" },
  { to: "/events", label: "Events" },
  { to: "/about", label: "About" },
  { to: "/csr", label: "CSR" },
  { to: "/volunteer", label: "Volunteer" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-[#F9F8F6]/95 backdrop-blur border-b border-[#0A2540]/10"
    >
      <div className="mx-auto max-w-7xl container-x flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <div className="w-12 h-12 rounded-lg overflow-hidden flex items-center justify-center">
            <img src={FOUNDATION_LOGO} alt="UB Maitreya Foundation" className="w-full h-full object-cover" />
          </div>
          <div className="leading-tight">
            <div className="font-serif-display text-[#0A2540] font-semibold text-lg">
              UB Maitreya
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#4A5568]">
              Foundation
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[#0A2540]" : "text-[#4A5568] hover:text-[#0A2540]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/donate"
            data-testid="header-donate-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#0A2540] text-white px-6 py-2.5 text-sm font-medium hover:bg-[#D4AF37] hover:text-[#0A2540] transition-colors"
          >
            <Heart className="w-4 h-4" strokeWidth={1.75} /> Donate
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#0A2540]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#0A2540]/10 bg-[#F9F8F6]">
          <div className="mx-auto max-w-7xl container-x py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-base ${isActive ? "text-[#0A2540]" : "text-[#4A5568]"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              onClick={() => setOpen(false)}
              data-testid="mobile-donate-btn"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#0A2540] text-white px-6 py-3 font-medium"
            >
              <Heart className="w-4 h-4" /> Donate & Become a UB Mitra
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
